'use client';

import type { PraticeQuestionType } from '@/types';
import PracticeQuestionExplanation from '@/components/practiceExams/PracticeQuestionExplanation';
import QuestionMarkdownRenderer from '@/components/QuestionMarkdownRenderer';
import { Box, Card, CardContent, FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { useState } from 'react';
const MarketingQuestionCard = ({
  question
}: {
  question: PraticeQuestionType;
}) => {
  const [showAnswer, setShowAnswer] = useState(false);
  const [selected, setSelected] = useState<string | string[]>([]);
  const answers = question?.answers || [];
  const handleAnswerSelect = (value: string) => {
    setSelected(value);
    setShowAnswer(true);
  };
  return <Box mb={4} data-sentry-element="Box" data-sentry-component="MarketingQuestionCard" data-sentry-source-file="MarketingQuestionCard.tsx">
      <Typography variant="h4" component="h2" fontWeight={600} gutterBottom sx={{
      mb: 6,
      textAlign: 'center'
    }} data-sentry-element="Typography" data-sentry-source-file="MarketingQuestionCard.tsx">
        Try out a practice question
      </Typography>
      <Card raised={showAnswer} sx={{
      boxShadow: {
        xs: 4,
        sm: 2
      }
    }} elevation={3} data-sentry-element="Card" data-sentry-source-file="MarketingQuestionCard.tsx">
        <CardContent data-sentry-element="CardContent" data-sentry-source-file="MarketingQuestionCard.tsx">
          <Stack direction="row" justifyContent="space-between" alignItems="baseline" mb={2} data-sentry-element="Stack" data-sentry-source-file="MarketingQuestionCard.tsx">
            <Box data-sentry-element="Box" data-sentry-source-file="MarketingQuestionCard.tsx">
              <QuestionMarkdownRenderer content={question.text} data-sentry-element="QuestionMarkdownRenderer" data-sentry-source-file="MarketingQuestionCard.tsx" />
            </Box>
          </Stack>
          <RadioGroup value={selected as string} onChange={e => handleAnswerSelect(e.target.value)} data-sentry-element="RadioGroup" data-sentry-source-file="MarketingQuestionCard.tsx">
            <Stack spacing={1} data-sentry-element="Stack" data-sentry-source-file="MarketingQuestionCard.tsx">
              {answers.map((a: any, index: number) => <FormControlLabel sx={showAnswer && (selected === String(a.id) || a.isCorrect) ? {
              backgroundColor: a.isCorrect ? '#d4edda' : 'transparent',
              border: a.isCorrect ? '2px solid #2e7d32' : '1px solid #EE3D45',
              ml: 0,
              py: 1
            } : {
              ml: 0,
              pt: {
                xs: index === 0 ? 0 : 1,
                sm: 0
              },
              pb: {
                xs: 1,
                sm: 0
              }
            }} key={a.id} value={String(a.id)} control={<Radio />} label={a.text} />)}
            </Stack>
          </RadioGroup>
          {showAnswer ? <Box>
                  <Typography variant="body1">
                    <PracticeQuestionExplanation defaultExpanded explanation={question.explanation} />
                  </Typography>
                </Box> : null}
        </CardContent>
      </Card>
    </Box>;
};
export default MarketingQuestionCard;